// ** React Imports
import { Fragment, lazy, useContext, useEffect } from "react"
import { Navigate } from "react-router-dom"
// ** Layouts
import BlankLayout from "@layouts/BlankLayout"
import VerticalLayout from "@src/layouts/VerticalLayout"
import HorizontalLayout from "@src/layouts/HorizontalLayout"
import LayoutWrapper from "@src/@core/layouts/components/layout-wrapper"

// ** Route Components
import PublicRoute from '@components/routes/PublicRoute'
// import PrivateRoute from '@components/routes/PrivateRoute'

// ** Utils
import { isObjEmpty } from "@utils"
import AuthenticationRoutes from "./authenticationRoutes"


import userRoutes from "./userRoutes";
import sellerRoutes from "./sellerRoutes";
import wholesalerRoutes from "./wholesalerRoutes";
import adminRoutes from "./adminRoutes";
import affiliateRoutes from "./affiliateRoutes"

// import ProductListing from "../../views/LandingPage/ProductListing"
// import { RoleContext } from "../../views/RoleContext"

const getLayout = {
  blank: <BlankLayout />,
  vertical: <VerticalLayout />,
  horizontal: <HorizontalLayout />
}

// ** Document title
const TemplateTitle = "Maelano"

// ** Default Route
const DefaultRoute = "/landingpage"

// const Home = lazy(() => import("../../views/Home"))
// const SecondPage = lazy(() => import("../../views/SecondPage"))
// const Login = lazy(() => import("../../views/Login"))
// const Register = lazy(() => import("../../views/Register"))
// const ForgotPassword = lazy(() => import("../../views/ForgotPassword"))
// const Error = lazy(() => import("../../views/Error"))

const getRoutesArray = () => {
  let userData = JSON.parse(localStorage.getItem('userData'));
  let backendRoles = userData?.roles?.map((item) => item.role);
  let role = localStorage.getItem('selectedRole');

  return [
    ...AuthenticationRoutes,
    ...(role === 'customer' && backendRoles?.includes(role) ? userRoutes : []),
    ...(role === 'seller' && backendRoles?.includes(role) ? sellerRoutes : []),
    ...(role === 'wholesaler' && backendRoles?.includes(role) ? wholesalerRoutes : []),
    ...(role === 'admin' && backendRoles?.includes(role) ? adminRoutes : []),
    ...(role === 'affiliate' && backendRoles?.includes(role) ? affiliateRoutes : []),
  ];
};

const getRouteMeta = (route) => {
  if (isObjEmpty(route.element.props)) {
    if (route.meta) {
      return { routeMeta: route.meta }
    } else {
      return {}
    }
  }
}

// ** Return Filtered Array of Routes & Paths
const MergeLayoutRoutes = (layout, defaultLayout, Routes) => {
  const LayoutRoutes = []

  // console.log("MergeLayoutRoutes Routes : ",Routes);

  if (Routes) {
    Routes.filter((route) => {
      let isBlank = false
      // ** Checks if Route layout or Default layout matches current layout
      if (
        (route.meta && route.meta.layout && route.meta.layout === layout) ||
        ((route.meta === undefined || route.meta.layout === undefined) &&
          defaultLayout === layout)
      ) {
        const RouteTag = PublicRoute

        // ** Check for public or private route
        if (route.meta) {
          route.meta.layout === "blank" ? (isBlank = true) : (isBlank = false)
        }
        if (route.element) {
          const Wrapper =
            // eslint-disable-next-line multiline-ternary
            isObjEmpty(route.element.props) && isBlank === false
              ? // eslint-disable-next-line multiline-ternary
              LayoutWrapper
              : Fragment

          route.element = (
            <Wrapper {...(isBlank === false ? getRouteMeta(route) : {})}>
              <RouteTag route={route}>{route.element}</RouteTag>
            </Wrapper>
          )
        }

        // Push route to LayoutRoutes
        LayoutRoutes.push(route)
      }
      return LayoutRoutes
    })
  }
  return LayoutRoutes
}

const getRoutes = (layout) => {
  const defaultLayout = layout || "vertical"
  const layouts = ["vertical", "horizontal", "blank"]
  const Routes = getRoutesArray();

  const AllRoutes = []

  layouts.forEach((layoutItem) => {
    const LayoutRoutes = MergeLayoutRoutes(layoutItem, defaultLayout, Routes)

    AllRoutes.push({
      path: "/",
      element: getLayout[layoutItem] || getLayout[defaultLayout],
      children: LayoutRoutes
    })
  })
  return AllRoutes
}

export { DefaultRoute, TemplateTitle, getRoutes };
